import { Box, Typography } from "@mui/material";
import { ReactComponent as QRcodeIcon } from '../../img/walletQRcode.svg';
import { colors } from '../../Theme/tokens';

export default function QRcode() {
  return (
    <Box mt={2} sx={{ borderRadius: '18px', padding: '20px', display: 'flex', gap: '5px', backgroundColor: colors.background.infoPanel, flexDirection: 'column' }}>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: '5px', justifyContent: 'center' }}>
        <Typography variant='h3' sx={{ lineHeight: '37px' }}>TradeTogether Wallet Information</Typography>
      </Box>

      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '10px', mt: 3 }}>
        <QRcodeIcon />
        <Typography sx={{ fontWeight: 500, fontSize: '18px', color: colors.neutral.outlinedText, lineHeight: '30px' }}>Scan QR Code</Typography>
      </Box>

    </Box>
  )
}
